import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ scrolled }) => {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();

  const handlePortalClick = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <div className="text-2xl font-bold">
              <span className="text-[#d97841]">FXC</span>
              <span className={scrolled ? 'text-gray-900' : 'text-white'}>
                {' '}Management Services
              </span>
            </div>
            <div className="h-0.5 w-32 bg-[#0d6571] ml-2 mt-2"></div>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="/"
              className={`transition-colors hover:text-[#d97841] ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </a>
            <a
              href="/news"
              className={`transition-colors hover:text-[#d97841] ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Latest News
            </a>
            <a
              href="/services"
              className={`transition-colors hover:text-[#d97841] ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </a>
            
            <a
              href="/contact"
              className={`transition-colors hover:text-[#d97841] ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </a>
            {isAuthenticated ? (
              <div className="flex items-center gap-4">
                <Button
                  onClick={handlePortalClick}
                  variant="outline"
                  className={`border-2 rounded-full px-6 transition-all hover:bg-[#0d6571] hover:text-white hover:border-[#0d6571] ${
                    scrolled
                      ? 'border-[#0d6571] text-[#0d6571]'
                      : 'border-white text-white'
                  }`}
                >
                  Dashboard
                </Button>
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  className={scrolled ? 'text-gray-700' : 'text-white'}
                >
                  Logout
                </Button>
              </div>
            ) : (
              <Button
                onClick={handlePortalClick}
                variant="outline"
                className={`border-2 rounded-full px-6 transition-all hover:bg-[#0d6571] hover:text-white hover:border-[#0d6571] ${
                  scrolled
                    ? 'border-[#0d6571] text-[#0d6571]'
                    : 'border-white text-white'
                }`}
              >
                Portal
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
